import { useState } from "react"
import { Input } from "web/components/Form/Controls"
import { TileSizeSelectors } from "web/components/Tiles"
import { ToggleWithLabelAndDescription } from "web/components"
import TileWizardActions from "web/components/AddTileWizard/TileWizardActions"

export function TileMilestoneSettingsModal({
  backButtonHandler,
  close,
  tile,
  tileEntry,
  overview,
}) {
  const [title, setTitle] = useState({ value: tile.name })
  const [tileWidth, setTileWidth] = useState({
    value: tileEntry.width,
  })
  const [showUpcomingOnly, setShowUpcomingOnly] = useState(
    tile.show_upcoming_only || false
  )
  const [showEmptyValues, setShowEmptyValues] = useState(
    tile.show_empty_values !== undefined ? tile.show_empty_values : true
  )

  async function handleTileWidthChange(selectedOption) {
    await overview.update({
      [overview.type]: {
        tile_entries_attributes: [
          {
            id: tileEntry.id,
            width: selectedOption.value,
          },
        ],
      },
    })

    setTileWidth(selectedOption)
  }

  async function handleSave() {
    const updates = {
      overview_tile: {
        name: title.value.trim(),
        show_upcoming_only: showUpcomingOnly,
        show_empty_values: showEmptyValues,
      },
    }

    if (title && title.value && /\S/.test(title.value)) {
      await tile.update(updates)
    }

    close()
  }

  return (
    <>
      <div className="modal-content-above-commands">
        <div className="mb-4 flex items-end">
          <Input label="Title" value={title} onChange={setTitle} />
        </div>
        <div className="mb-4">
          <TileSizeSelectors
            tileWidth={tileWidth}
            setTileWidth={handleTileWidthChange}
            limitTileSizeOptions={{ width: 2, height: 0 }}
          />
        </div>
        <div className="mb-4 rounded-md border px-4 py-4 shadow-sm">
          <div className="mb-3 text-lg font-bold">Options</div>
          <div className="grid grid-cols-2 gap-x-5 gap-y-3">
            <ToggleWithLabelAndDescription
              label="Upcoming Milestones Only"
              description="Show milestones happening today or later."
              checked={showUpcomingOnly}
              onChange={setShowUpcomingOnly}
            />
            <ToggleWithLabelAndDescription
              label="Include Blank Milestones"
              description="Show milestones that don't have dates."
              checked={showEmptyValues}
              onChange={setShowEmptyValues}
            />
          </div>
        </div>
      </div>
      <TileWizardActions
        backButtonHandler={backButtonHandler}
        onSaveHandler={handleSave}
      />
    </>
  )
}
